import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SelectGroup } from 'cstar-react-primitives/lib/formik/index';
import { LinkButton } from 'cstar-react-primitives';

import { cashbotName } from '../../core';
import { useFormatMessage } from '../../../intl/intlHooks';
import { shippingMethodField } from './formFieldMessages';
import { FieldError } from '../../core/FieldError';
import {shippingMessages} from '../lineItem/lineItemMessages';

export const shippingMethodsSort = (shipMethodA, shipMethodB) => {
    if (parseFloat(shipMethodA.cost) < parseFloat(shipMethodB.cost)) {
        return -1;
    }
    if (parseFloat(shipMethodA.cost) > parseFloat(shipMethodB.cost)) {
        return 1;
    }
    return 0;
};

const makeShippingOptionsList = (intl, shippingMethods) => {
    if (shippingMethods === undefined || shippingMethods.length === 0) return [];
    const values = Object.values(shippingMethods);
    return values.map(value => ({
        value: value.token,
        label: `${intl.formatNumber(value.cost, {
            style: 'currency',
            currency: value.currencyCode
        })} (${value.displayName})`
    }));
};

export const ShippingMethodFormikField = ({ name, label, aria, isRequiredField, options }) => (
    <Field
        name={name}
        label={label}
        component={SelectGroup}
        aria-label={aria}
        cashbotName={cashbotName}
        isRequiredField={isRequiredField}
        options={options}
    />
);

export const ShippingMethodSelector = ({ name, shippingMethods, isLoading, error, linkProps }) => {
    const formatMessage = useFormatMessage();
    const pureShippingMethodsSelectorProps = {
        name,
        label: formatMessage(shippingMethodField.shippingMethodLabel),
        aria: formatMessage(shippingMethodField.shippingMethodLabel),
        isRequiredField: true,
        options: makeShippingOptionsList(useIntl(), shippingMethods)
    };

    return (
        <React.Fragment>
            {isLoading ? <div>Loading ...</div> : <ShippingMethodFormikField {...pureShippingMethodsSelectorProps} />}
            {error && (
                <div className="below-shipping-method-select">
                    <FieldError message={formatMessage(shippingMessages.shippingMethodsErrorLabel)} />
                    <LinkButton {...linkProps}>{formatMessage(linkProps.linkMessage)}</LinkButton>
                </div>
            )}
        </React.Fragment>
    );
};

ShippingMethodFormikField.defaultProps = {
    isRequiredField: undefined,
    options: undefined,
    label: ''
};

ShippingMethodFormikField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    aria: PropTypes.string.isRequired,
    isRequiredField: PropTypes.bool,
    options: PropTypes.array
};

ShippingMethodSelector.propTypes = {
    name: PropTypes.string.isRequired,
    shippingMethods: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    numFetches: PropTypes.number.isRequired,
    linkProps: PropTypes.object.isRequired
};
